import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { setLastDrawerHeight } from '../../applications/stores/applications-store-actions';
import SbomDrawer from '../components/SbomDrawer';
import SbomStore from '../stores/sbom-store';

const SbomDrawerContainer: FC<
  React.PropsWithChildren<SbomDrawerContainerProp>
> = ({ className }) => {
  const { selectedSbom, lastDrawerHeight } = useSnapshot(SbomStore);

  if (!selectedSbom) {
    return null;
  }

  return (
    <SbomDrawer
      className={className}
      sbom={selectedSbom}
      loading={false}
      defaultHeight={lastDrawerHeight}
      onResizeStop={setLastDrawerHeight}
    />
  );
};

interface SbomDrawerContainerProp {
  className: string;
}

export default SbomDrawerContainer;
